(ns io.daskul.tutorial.webapp.views.settings
  "Settings page — account (password) and integrations (Facebook Messenger),
   laid out as full-width section cards in the main content area."
  (:require
   [uix.core :refer [defui $]]
   [uix.re-frame :as urf]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.tutorial.webapp.domain.auth.subs :as auth.subs]
   [io.daskul.tutorial.webapp.hooks.feature-flags :as ff]
   [io.daskul.tutorial.webapp.views.change-password :as change-password]
   [io.daskul.tutorial.webapp.views.facebook-pages :as facebook-pages]))

(defui settings-page []
  (let [role (urf/use-subscribe [::auth.subs/role])
        messaging-enabled? (ff/use-feature-flag "facebook-messaging")]
    ($ ui/stack {:gap "lg" :maw 760 :pt "xs"}
       ($ ui/title {:order 2} "Settings")
       ($ ui/paper {:withBorder true :p "xl" :radius "md"}
          ($ change-password/password-section))
      ;; SMS-56: Facebook Page connection is an org-level (school-admin) concern.
      ;; Gate on role AND the facebook-messaging flag: when the feature is off
      ;; for this school the connect UI shouldn't appear at all (the nav hides
      ;; the inbox on the same flag — this keeps settings consistent). The card
      ;; also never mounts otherwise — facebook-section's mount effect would fire
      ;; a /facebook-pages list request the backend 403s for non-school-admins.
       (when (and messaging-enabled? (#{"school-admin"} role))
         ($ ui/paper {:withBorder true :p "xl" :radius "md"}
            ($ facebook-pages/facebook-section))))))
